import { withParams } from 'vuelidate';
import XRegExp from 'xregexp';
export default (pattern) => withParams({ type: 'pattern	' }, value => {
	if (typeof value === 'undefined' || value === null || value === '') {
		return true;
	}
	let reg = new XRegExp(pattern);
	return reg.test(value);
});
